import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';

import { PrintNode_get_printers_by_location_flowService } from './PrintNode.flow.index';
import { PrintNode_print_request_flowService } from './PrintNode.flow.index';
import { PrintNode_set_device_associations_by_type_flowService } from './PrintNode.flow.index';
import { PrintNode_validate_credentials_flowService } from './PrintNode.flow.index';

import { $frontendTypes } from './PrintNode.frontend.types'

@Injectable({ providedIn: 'root' })
export class PrintNode_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
  }

    public Utilities: Utilities_FlowService;
  public PrintNode: PrintNode_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _get_printers_by_location_flow: PrintNode_get_printers_by_location_flowService;
  public async get_printers_by_location_flow(inParams: { location_id: number }): Promise< { reasons?: string[], printers?: { letter_printer: { id: number, name: string }, label_printer: { id: number, name: string } } }> {
    if(!this._get_printers_by_location_flow) { 
      this._get_printers_by_location_flow = this.injector.get(PrintNode_get_printers_by_location_flowService);
    }
    return this._get_printers_by_location_flow.run(inParams);
  }
   
   

   
 
  private _print_request_flow: PrintNode_print_request_flowService;
  public async print_request_flow(inParams: { printerId: number, content: string, contentType?: string }): Promise< { outputDetails?: string, printJobId?: number }> {
    if(!this._print_request_flow) { 
      this._print_request_flow = this.injector.get(PrintNode_print_request_flowService);
    }
    return this._print_request_flow.run(inParams);
  }
   
   

   
 
  private _set_device_associations_by_type_flow: PrintNode_set_device_associations_by_type_flowService;
  public async set_device_associations_by_type_flow(inParams: { entity_type: $frontendTypes.PrintNode.e_entity_type, entity_id: string, device_ids: string[], device_type: $frontendTypes.PrintNode.e_device_type }): Promise< { reasons?: string[] }> {
    if(!this._set_device_associations_by_type_flow) { 
      this._set_device_associations_by_type_flow = this.injector.get(PrintNode_set_device_associations_by_type_flowService);
    }
    return this._set_device_associations_by_type_flow.run(inParams);
  }
   
   

   
 
  private _validate_credentials_flow: PrintNode_validate_credentials_flowService;
  public async validate_credentials_flow(inParams: {  }): Promise< { validation?: string, outputDetails?: string }> {
    if(!this._validate_credentials_flow) { 
      this._validate_credentials_flow = this.injector.get(PrintNode_validate_credentials_flowService);
    }
    return this._validate_credentials_flow.run(inParams);
  }
   
   

   
}
